<template>
  <div class="row">
    <div class="col-xl-4 col-xxl-3">
      <GalleriSearchField
        v-if="mobileSized()"
        :baseApiUrl="baseApiUrl"
        :queryString="queryString"
      >
      </GalleriSearchField>

      <div v-if="mobileSized()" id="galleriFilterMobile" class="accordion">
        <div class="accordion-item">
          <div class="accordion-header" id="ahmobile">
            <button 
              class="accordion-button collapsed" 
              type="button" 
              data-bs-toggle="collapse" 
              data-bs-target="#acmobile" 
              aria-expanded="false" 
              aria-controls="acmobile" 
            >
              <span class="accordion-button-text">Filter</span>
            </button>
          </div>
          <div id="acmobile" class="accordion-collapse collapse" aria-labelledby="ahmobile">
            <div class="accordion-body">
              <GalleriFilter 
                :programFilter="programFilter"
                :arskursFilter="arskursFilter"
                :projekttypFilter="projekttypFilter"
                :anpassadeAlternativFilter="anpassadeAlternativFilter"
                :anpassadeAlternativLabel="anpassadeAlternativLabel"
                :arFilter="arFilter"
                :urlSearchParams="usp"
                :currentTags="currentTags"
              >
              </GalleriFilter>
            </div>
          </div>
        </div>
      </div>

      <GalleriFilter 
        v-else
        :programFilter="programFilter"
        :arskursFilter="arskursFilter"
        :projekttypFilter="projekttypFilter"
        :anpassadeAlternativFilter="anpassadeAlternativFilter"
        :anpassadeAlternativLabel="anpassadeAlternativLabel"
        :arFilter="arFilter"
        :urlSearchParams="usp"
        :currentTags="currentTags"
      >
      </GalleriFilter>
    </div>
    <div class="col-xl-8 col-xxl-9">
      <GalleriSearchField
        v-if="!mobileSized()"
        :baseApiUrl="baseApiUrl"
        :queryString="queryString"
      >
      </GalleriSearchField>
      <GalleriFilterBar 
        v-if="filtersCombined && currentTags.length > 0"
        :filtersCombined="filtersCombined"
        :currentTags="currentTags"
      >
      </GalleriFilterBar>
      <GalleriResult
        :result="pagedResult"
        :totalMatching="totalMatching"
        :totalMatchingText="totalMatchingText"
        :take="take"
      >
      </GalleriResult>
      <Pagination
        v-if="result && result.length > 0 && totalMatching > take"
        :items="result"
        :totalMatching="totalMatching"
        :labels="texts"
        :pageSize="take"
        @changePage="onChangePage"
      >
      </Pagination>
    </div>
  </div>
</template>

<script>
import galleriService from "../plugins/galleriService";
import GalleriFilter from "./components/galleriFilter.vue";
import GalleriSearchField from "./components/galleriSearchField.vue";
import GalleriFilterBar from "./components/galleriFilterBar.vue";
import GalleriResult from "./components/galleriResult.vue";
import Pagination from "common/js/vue/pagination/pagination.vue";

export default {
  name: "Galleri",
  props: {
    baseApiUrl: String,
    queryString: String,
    siteLang: String,
    sitePageId: String,
    texts: Object,
    anpassadeAlternativLabel: String,
  },
  components: {
    GalleriFilter,
    GalleriSearchField,
    GalleriFilterBar,
    GalleriResult,
    Pagination,
  },
  data: function () {
    return {
      result: undefined,
      pagedResult: undefined,
      totalMatching: 0,
      totalMatchingText: "",
      take: 12,
      isLoading: false,
      programFilter: undefined,
      arskursFilter: undefined,
      projekttypFilter: undefined,
      anpassadeAlternativFilter: undefined,
      arFilter: undefined,
      filtersCombined: undefined,
      query: "",
      program: "",
      arskurs: "",
      projekttyp: "",
      anpassatAlternativ: "",
      ar: "",
      usp: undefined,
      currentTags: [],
      screenWidth: window.innerWidth
    };
  },
  provide() {
    return {
      galleriService: galleriService,
      getItems: this.getItems,
      getPage: this.getPage,
      initCurrentTags: this.initCurrentTags,
      mobile: this.mobileSized,
      split: this.split
    };
  },
  created() {
    this.$.appContext.app.config.globalProperties = {
      $texts: this.texts,
      $lang: this.siteLang,
      $searchObj: Object.create(null)
    }

    this.usp = new URLSearchParams(window.location.search);
    this.initValuesFromUrl();
    this.getFilter();
    this.getItems(this.$searchObj);

    window.addEventListener("resize", () => {
      this.screenWidth = window.innerWidth;
    });
  },
  methods: {
    getFilter() {
      galleriService
        .getGalleriFilter(this.baseApiUrl, this.sitePageId, this.siteLang)
        .then((result) => {
          if (result && result.status == 200) {
            this.programFilter = result.data.programFilter;
            this.arskursFilter = result.data.arskursFilter;
            this.projekttypFilter = result.data.projekttypFilter;
            this.anpassadeAlternativFilter = result.data.anpassadeAlternativFilter
            this.arFilter = result.data.arFilter;
            this.filtersCombined = this.programFilter.concat(this.arskursFilter, this.projekttypFilter, this.arFilter, this.anpassadeAlternativFilter);
          }
        })
        .catch((e) => {
          console.log(`getFilter failed: ${e}`);
        });
    },
    getItems(searchObj) {
      this.isLoading = true;

      this.query = !_.isUndefined(searchObj.query) ? searchObj.query : this.query;
      this.program = !_.isUndefined(searchObj.program) ? searchObj.program : this.program;
      this.arskurs = !_.isUndefined(searchObj.arskurs) ? searchObj.arskurs : this.arskurs;
      this.projekttyp = !_.isUndefined(searchObj.projekttyp) ? searchObj.projekttyp : this.projekttyp;
      this.anpassatAlternativ = !_.isUndefined(searchObj.anpassatAlternativ) ? searchObj.anpassatAlternativ : this.anpassatAlternativ;
      this.ar = !_.isUndefined(searchObj.ar) ? searchObj.ar : this.ar;

      galleriService
        .getGalleriResult(
          this.baseApiUrl,
          this.query,
          this.program,
          this.arskurs,
          this.projekttyp,
          this.anpassatAlternativ,
          this.ar,
          this.sitePageId,
          this.siteLang
        )
        .then((result) => {
          if (result && result.status == 200) {
            this.result = result.data.items;
            this.totalMatching = result.data.totalMatching;

            if (this.$searchObj.filtering || _.isEmpty(this.pagedResult)) {
              this.pagedResult = this.result;
            }
            
            this.getTotalMatchingText();
            this.isLoading = false;
          }
        })
        .catch((e) => {
          console.log(`getItems failed: ${e}`);
          this.isLoading = false;
        });
    },
    getPage() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get("page") != null
        ? parseInt(urlParams.get("page"))
        : 1;
    },
    onChangePage(page) {
      this.$searchObj.page = page;
      this.getTotalMatchingText();
      let block = document.getElementById("galleriResult");
      let total = block.querySelector(".visually-hidden.total");
      total.focus();
    },
    initValuesFromUrl() {
      let query = this.usp.get("q");
      this.query = query ? query : this.query;

      let program = this.usp.get("program");
      this.program = program ? program : this.program;
      program = this.split(program);

      let arskurs = this.usp.get("arskurs");
      this.arskurs = arskurs ? arskurs : this.arskurs;
      arskurs = this.split(arskurs);

      let projekttyp = this.usp.get("projekttyp");
      this.projekttyp = projekttyp ? projekttyp : this.projekttyp;
      projekttyp = this.split(projekttyp);

      let anpassatAlternativ = this.usp.get("anpassatAlternativ");
      this.anpassatAlternativ = anpassatAlternativ ? anpassatAlternativ : this.anpassatAlternativ;
      anpassatAlternativ = this.split(anpassatAlternativ);

      let ar = this.usp.get("ar");
      this.ar = ar ? ar : this.ar;
      ar = this.split(ar);

      this.currentTags = [...new Set(this.currentTags.concat(program, arskurs, projekttyp, ar, anpassatAlternativ))];
    },
    initCurrentTags(values) {
      this.currentTags = [...new Set(this.currentTags.concat(values))];
    },
    getTotalMatchingText() {
      if (this.totalMatching > this.take) {
        let page = this.$searchObj.page ? this.$searchObj.page : this.getPage();
        let start = (page - 1) * this.take + 1;
        let end =
          page * this.take <= this.totalMatching
            ? page * this.take
            : this.totalMatching;
        
        this.totalMatchingText = `${this.texts.visar} ${start}-${end} ${this.texts.av} ${this.totalMatching}`;
      }
    },
    mobileSized() {
      return this.screenWidth < 1200;
    },
    split(str) {
      return str ? str.split(",") : [];
    }
  }
};
</script>
